var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-col profile-container" }, [
    _c(
      "div",
      { staticClass: "profile-details" },
      [
        _c("div", { staticClass: "pb-1" }, [
          _c(
            "button",
            {
              staticClass: "copy-token-button left-align",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.copyToken()
                },
              },
            },
            [
              _vm._v(" " + _vm._s(_vm.$t("copyToken")) + " "),
              _c("font-awesome-icon", { attrs: { icon: "copy" } }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "pb-1" }, [
          _c(
            "a",
            {
              staticClass: "swagger-link",
              attrs: { href: _vm.swaggerURL, target: "_blank" },
            },
            [_vm._v(" " + _vm._s(_vm.$t("openSwagger")) + " ")]
          ),
        ]),
        _c("div", { staticClass: "flex-col flex-3 pb-1" }, [
          _c("div", { staticClass: "version" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("version")) + " " + _vm._s(_vm.version) + " "
            ),
          ]),
          _c("div", { staticClass: "version " }, [
            _vm._v(" " + _vm._s(_vm.$t("apiUrl")) + "  "),
            _c(
              "a",
              { staticClass: "swagger-link", attrs: { href: _vm.apiUrl } },
              [_vm._v(" " + _vm._s(_vm.apiUrl) + " ")]
            ),
          ]),
        ]),
        _vm.shouldShowFeedbackButton
          ? _c(
              "pui-button",
              {
                staticClass: "profile-action-button",
                attrs: { state: "secondary", icon: "report" },
                on: {
                  click: function ($event) {
                    return _vm.sendToFeedback()
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("sendFeedback")) + " ")]
            )
          : _vm._e(),
        _vm.shouldShowFeedbackButton
          ? _c(
              "pui-button",
              {
                staticClass:
                  "profile-action-button profile-action-button--important",
                attrs: { state: "secondary", icon: "warning" },
                on: {
                  click: function ($event) {
                    return _vm.sendToIncident()
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("reportIncident")) + " ")]
            )
          : _vm._e(),
        _vm.shouldShowFeedbackButton
          ? _c(
              "pui-button",
              {
                staticClass:
                  "profile-action-button profile-action-button--important",
                attrs: { state: "secondary", icon: "warning" },
                on: {
                  click: function ($event) {
                    return _vm.goToQueryHub()
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("queryHub.goToQueryHub")) + " ")]
            )
          : _vm._e(),
        _c(
          "pui-button",
          {
            staticClass: "profile-action-button",
            attrs: { icon: "power" },
            on: {
              click: function ($event) {
                return _vm.logOut()
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("signOut")) + " ")]
        ),
      ],
      1
    ),
    _c("input", {
      staticClass: "copy-text",
      attrs: { type: "text", id: "copyText" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }